export const CrmObjectTypes = Object.freeze({
  CONTACT: 'CONTACT',
  COMPANY: 'COMPANY',
  DEAL: 'DEAL',
  TICKET: 'TICKET',
  PRODUCT: 'PRODUCT',
  QUOTE: 'QUOTE',
  MARKETING_EVENT: 'MARKETING_EVENT',
  LINE_ITEM: 'LINE_ITEM',
  APPOINTMENT: 'APPOINTMENT',
  SERVICE: 'SERVICE',
  LISTING: 'LISTING',
  COURSE: 'COURSE'
});